import React from "react"
import styles from "./styles.scss"
import Slider from "react-slick"
import "slick-carousel/slick/slick-theme.css"
import "slick-carousel/slick/slick.css"
import { TeamMember, teamMembers } from "../TeamMembers"
import cx from "classnames"

const settings = {
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  centerMode: true,
  focusOnSelect: true,
  swipeToSlide: true,
  touchThreshold: 10,
}

class Carousel extends React.Component {
  componentDidMount() {
    window.addEventListener("touchstart", this.touchStart)
    window.addEventListener("touchmove", this.preventTouch, { passive: false })
  }

  componentWillUnmount() {
    window.removeEventListener("touchstart", this.touchStart)
    window.removeEventListener("touchmove", this.preventTouch, {
      passive: false,
    })
  }

  touchStart(e) {
    this.firstClientX = e.touches[0].clientX
    this.firstClientY = e.touches[0].clientY
  }

  preventTouch(e) {
    console.log(e)
    const minValue = 50
    this.clientX = e.touches[0].clientX - this.firstClientX
    this.clientY = e.touches[0].clientY - this.firstClientY

    // Vertical scrolling does not work when you start swiping horizontally.
    if (Math.abs(this.clientX) > minValue) {
      e.preventDefault()
      e.returnValue = false
      return false
    }
  }

  render() {
    return (
      <Slider
        className={cx(styles.carousel, this.props.className)}
        {...settings}
      >
        {teamMembers.map(tm => (
          <TeamMember key={tm.name} {...tm} />
        ))}
      </Slider>
    )
  }
}

export default Carousel



// WEBPACK FOOTER //
// ./src/components/JobDescription/Team/Carousel/index.jsx